<div class="modal-heading modal-heading-1 d-flex align-items-center justify-content-between mce-tinyfilemanager.net">
  <div class="label_name">Image Manager</div>
  <button class="mce-close btn btn-link" (click)="closeModal()">
    <fa-icon [icon]="['fas', 'times']"></fa-icon>
  </button>
</div>

<div class="modal-body p-0 min-height">
  <div class="link-field-wrapper">
    <input #link class="link-field mce-img_{{track}}" type="text" />
  </div>

  <div class="uploader d-flex flex-column align-items-center" *ngIf="isUploading">

    <form *ngIf="uploadForm" [formGroup]="uploadForm" enctype="multipart/form-data" novalidate>
      <input id="file-upload" type="file" (change)="selectFiles($event)" multiple="multiple" />
      
      <label for="file-upload" class="btn btn primary w-100 text-center">
        <span class="text-center"><fa-icon [icon]="uploadIcon"></fa-icon> Click here to select files</span>      
      </label>

      <div *ngFor="let control of getFileControls()">
        Name: {{ control?.value?.name }}
      </div>

    </form>
    <div class="btn-group toolbox">
      <button [disabled]="getFileControls().length < 1" class="btn btn-primary" (click)="uploadFiles()">Upload</button>

      <button (click)="toggleUploadForm()" class="btn btn-default close-uploader">
        <i class="icon-backward icon-white"></i> Return to files list
      </button>
    </div>
  </div>

  <div id="uploader-frame" class="uploader-container" *ngIf="!isUploading">
      <div class="container-fluid">
        <button (click)="toggleUploadForm()" class="btn btn-primary upload-btn">
          <fa-icon [icon]="uploadIcon"></fa-icon>
          Upload a file
        </button>

        <button *ngIf="allowFolders" class="ml-kh-2 btn btn-default" (click)="createFolder()">
          <fa-icon [icon]="folderIcon"></fa-icon>
          Create a Folder</button>
      </div>
      <div class="container-fluid">
        <div class="row-fluid">
          <ul class="breadcrumb">
            <li (click)="changeFolder('')" class="pointer">
              <fa-icon [icon]="homeIcon" class="pl-kh-3"></fa-icon>
            </li>
            <li *ngFor="let fragment of getBreadcrumbs(sourceFolder); let i = index">
                <span class="px-kh-2">/</span>
                <span *ngIf="i + 1 < getBreadcrumbs(sourceFolder).length" class="link pointer" (click)="changeFolder(getFragmentToIndex(i))">{{ fragment }}</span>
                <span *ngIf="i + 1 === getBreadcrumbs(sourceFolder).length" class="kh-black">{{ fragment }}</span>
            </li>
          </ul>
        </div>
  
        <div *ngIf="source$ | async as source" class="list-container d-flex flex-row justify-content-evenly align-items-start flex-wrap row-gap column-gap align-items-stretch">
          <div *ngFor="let folder of source.folders"  class="boxes img-thumbnail d-flex flex-column align-items-center flex-grow-1">
            <div class="d-flex justify-content-end w-100 pb-kh-2">
              <fa-icon (click)="deleteFolder(folder.fullPath)" [icon]="trashIcon" class="btn btn-default kh-btn"></fa-icon>
            </div>
            <kh-img class="d-inline-block" path="uploader/img/ico/folder.png"></kh-img>
            <div (click)="changeFolder(folder.fullPath)" class="kh-medium-title-text pointer">{{folder.name}}</div>
          </div>
  
          <div *ngFor="let file of source.files" class="boxes img-thumbnail d-flex flex-column align-items-center flex-grow-1">      
            <div class="btn-group toolbox d-flex justify-content-around w-100 pb-kh-2">
              <fa-icon (click)="downloadFile(file)" [icon]="downloadIcon" class="btn btn-default kh-btn"></fa-icon>
              <fa-icon *ngIf="file.id !== emptyGuid" (click)="deleteFile(file.id)" [icon]="trashIcon" class="btn btn-default kh-btn" style="border:0 !important"></fa-icon>
            </div>
  
            <ng-container [ngSwitch]="file.category">
              <img *ngSwitchCase="fileExtensionCategory.Image" [src]="file.thumbnailFullPath" class="d-inline-block img-thumbnail thumbnail">           
              <kh-img *ngSwitchDefault class="d-inline-block img-thumbnail thumbnail" [path]="'uploader/img/ico/'+getExtension(file.name)+'.png'"></kh-img>
            </ng-container>
            <div (click)="linkSelected(file)" class="kh-medium-title-text pointer">{{file.name}}</div>
          </div>
        </div>
      </div>
  </div>
</div>
